export default __webpack_public_path__ + "static/media/ms-icon.afc269d2.svg";